import React from "react";
import { useSelector } from "react-redux";
import Gravatar from "react-gravatar";

import useComponentVisible from "../../../Utils/useComponentVisible";
import { api } from "../../../Services/Api";
import { getMessagingToken } from "../../../Services/Firebase";
import { Container, Actions } from "./style";

export default function Profile() {
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  const userEmail = useSelector((state) => state.user.userData.email);

  const [showActions, setShowActions] = React.useState(false);

  function handleLogout() {
    getMessagingToken()
      .then((token) => {
        api.patch(`/notifications/push/deactivate-client?clientId=${token}`);
      })
      .catch((err) => {
        console.log("As notificações estão desabilitadas");
      })
      .finally(() => {
        localStorage.removeItem("token");
        window.location = "/#/login";
      });
  }

  function handleClick() {
    setIsComponentVisible(!isComponentVisible);
    //setShowActions(!showActions);
  }

  return (
    <Container ref={ref}>
      <Gravatar
        style={{ cursor: "pointer" }}
        onClick={handleClick}
        default="mm"
        className="avatar"
        email={userEmail || ""}
      />
      {isComponentVisible && (
        <Actions>
          <a href="/#/account">Minha conta</a>
          <a onClick={handleLogout} href="javascript:void(0)">
            Sair
          </a>
        </Actions>
      )}
    </Container>
  );
}
